import React from 'react';
import { subsidiesInfo } from '../data/mock';

const SubsidiesSection = () => {
  return (
    <section className="bg-gray-50 py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Content */}
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
              {subsidiesInfo.title}
            </h2>
            <div className="w-12 h-0.5 bg-gray-300 mb-8"></div>

            <p className="text-gray-600 leading-relaxed mb-8">
              {subsidiesInfo.description}
            </p>

            {/* Points */}
            <ul className="space-y-3">
              {subsidiesInfo.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-gray-700 text-sm">{point}</span>
                </li>
              ))}
            </ul>

            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-block mt-10 text-gray-900 font-medium text-sm border border-gray-300 px-6 py-2.5 rounded hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all duration-200"
            >
              En savoir plus
            </a>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1668097613572-40b7c11c8727?w=800&h=600&fit=crop"
              alt="Installation solaire"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubsidiesSection;
